export interface OptionAccent {
    solid: string;
    hover: string;
    ring: string;
}

export const optionAccents: OptionAccent[] = [
    { solid: 'bg-rose-500', hover: 'hover:bg-rose-600', ring: 'ring-rose-300 dark:ring-rose-700' },
    { solid: 'bg-sky-500', hover: 'hover:bg-sky-600', ring: 'ring-sky-300 dark:ring-sky-700' },
    { solid: 'bg-amber-500', hover: 'hover:bg-amber-600', ring: 'ring-amber-300 dark:ring-amber-700' },
    { solid: 'bg-emerald-500', hover: 'hover:bg-emerald-600', ring: 'ring-emerald-300 dark:ring-emerald-700' },
    { solid: 'bg-violet-500', hover: 'hover:bg-violet-600', ring: 'ring-violet-300 dark:ring-violet-700' },
    { solid: 'bg-cyan-500', hover: 'hover:bg-cyan-600', ring: 'ring-cyan-300 dark:ring-cyan-700' },
];
